import React from 'react'
import {Container, Row, Col} from 'reactstrap'
import { FaFacebookSquare, FaGooglePlusSquare, FaAws } from 'react-icons/fa';
import Link from './link';
import styled from "styled-components"

const Footer = styled.footer`
  padding: 2rem 0;
  background: linear-gradient(10deg,#943cff 0%,#dd45d3 40.13%,#fc9a57 90%);
  a, a:hover {
    color: inherit;
  }
  ul {
    color: rgba(0, 0, 0, 0.5);
    -webkit-padding-start: 0;
    padding: 0;
    & > li {
      list-style: none;
      a, a:hover {
        color: inherit;
      }
    }
  }
`

let SocialLink = ({to, Icon}) => (
  <Link to={to} className="mr-2">
    <Icon size={30}/>
  </Link>
)

let FooterLink = ({to, children}) => (
  <li>
    <Link to={to}>
      {children}
    </Link>
  </li>
)

export default () => (
  <Footer>
    <Container>
      <Row>
        <Col>
          <h5>Program</h5>
          <ul>
            <FooterLink to="/contact">Marti    17:30 - 20:30</FooterLink>
            <FooterLink to="/contact">Miercuri 17:30 - 20:30</FooterLink>
            <FooterLink to="/contact">Joi      17:30 - 20:30</FooterLink>
            <FooterLink to="/contact">Vineri   17:30 - 20:30</FooterLink>
          </ul>
        </Col>
        <Col>
          <h5>Personal</h5>
          <ul>
            <FooterLink to="mailto:radu.lois@gmail.com">Dr Lois Eugenia</FooterLink>
            <FooterLink to="mailto:radu.lois@gmail.com">Dr Lois Radu</FooterLink>
          </ul>
        </Col>
        <Col>
          <h5>Clinica</h5>
          <ul>
            <FooterLink to= "http://maps.google.com/?q=Medimage+Lois, Alba Iulia, Romania">Arnsberg 14, 510022 Alba Iulia Programari: 0745583894</FooterLink>
          </ul>
        </Col>
        <Col>
          <h5>Legaturi</h5>
          <SocialLink to= "https://www.facebook.com/Cabinet-imagistic%C4%83-MedImage-Loi%C5%9F-1700061440222353/" Icon={FaFacebookSquare}/>
          <SocialLink to= "http://www.lotuscode.eu" Icon={FaAws}/>
        </Col>
      </Row>
    </Container>
  </Footer>
)
